import { ROUTE_TESTING_PLAN_COMPLETE } from '@/constants/routes';
import { formatCancerTypeNameWithCapitalization } from '@/utils';
import { RouteObject } from 'react-router-dom';
import Page from './complete-test.page';

export const routeTestingPlanComplete: RouteObject = {
  path: ROUTE_TESTING_PLAN_COMPLETE,
  Component: Page,
  loader: ({ params }) => {
    document.title = `${formatCancerTypeNameWithCapitalization(params.idTestOption ?? '')}`;
    return null;
  },
};
